export default {
  "AgreementButton.Blue": "同意する",
  "AgreementButton.Gray": "同意済み",
}
